module.exports = "img/photo13.7740d7.jpeg";